import AccessKey from "./keysTree";
import {
	AccessTranslate,
	MetadataValue,
	BranchProperty,
	BranchKind,
} from "./interface";

/**
 * Default branch properties indicating whether a component or route should be visible.
 *
 * `BRANCH_DEFAULT` allows access to display the component or route.
 * `BRANCH_NOT_SHOW` denies access to display the component or route.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const [BRANCH_DEFAULT, BRANCH_NOT_SHOW]: [BranchProperty, BranchProperty] = [
	{ [AccessKey.SHOW]: true },
	{ [AccessKey.SHOW]: false },
];

/**
 * Branch kinds representing different access levels for various types of interface elements.
 *
 * `BRANCH_DEFAULT_MENU` corresponds to the menu access level.
 * `BRANCH_DEFAULT_PAGES` corresponds to the pages access level.
 * `BRANCH_DEFAULT_TABS` corresponds to the tabs access level.
 * `BRANCH_DEFAULT_BUTTONS` corresponds to the buttons access level.
 * `BRANCH_DEFAULT_WIDGETS` corresponds to the widgets access level.
 */
const [
	BRANCH_DEFAULT_MENU,
	BRANCH_DEFAULT_PAGES,
	BRANCH_DEFAULT_TABS,
	BRANCH_DEFAULT_BUTTONS,
	BRANCH_DEFAULT_WIDGETS,
	BRANCH_DEFAULT_MODALS,
	BRANCH_DEFAULT_FIELDS,
	BRANCH_DEFAULT_CHECK_BOXS,
	BRANCH_DEFAULT_CARD_ORDERS,
	BRANCH_DEFAULT_SELECTOR,
	BRANCH_DEFAULT_EDITORS,
	BRANCH_DEFAULT_RADIO_BUTTONS,
	BRANCH_DEFAULT_PERMISSION,
	BRANCH_DEFAULT_PERFORMER_CARD,
	BRANCH_DEFAULT_TRANSPORT_CARD,
	BRANCH_DEFAULT_BLOCKS,
]: BranchKind[] = [
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.MENU },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.PAGES },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.TABS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.BUTTONS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.WIDGETS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.MODALS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.FIELDS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.CHECK_BOXS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.CARD_ORDERS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.SELECTOR },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.EDITORS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.RADIO_BUTTONS },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.PERMISSION },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.PERFORMER_CARD },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.TRANSPORT_CARD },
	{ ...BRANCH_DEFAULT, [AccessKey.METADATA]: AccessKey.BLOCKS },
];

const BRANCH_CONTROL_BUTTONS = {
	[AccessKey.CONTROL_BUTTON_ADD]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.CONTROL_BUTTON_EDIT]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.CONTROL_BUTTON_DELETE]: BRANCH_DEFAULT_BUTTONS,
};

const BRANCH_CONTROL_AND_ADDITIONAL_BUTTONS = {
	...BRANCH_CONTROL_BUTTONS,
	[AccessKey.AFTER_ADDITIONAL_BUTTONS]: BRANCH_DEFAULT_BUTTONS,
};

const BRANCH_PANEL_POINT = {
	[AccessKey.ADD_POINT]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.INSERT_POINT]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.EDIT_POINT]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.DELETE_POINT]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.MOVE_POINT_UP]: BRANCH_DEFAULT_BUTTONS,
	[AccessKey.MOVE_POINT_DOWN]: BRANCH_DEFAULT_BUTTONS,
};

const BRANCH_FILTER_ORDER_MODAL = {
	[AccessKey.ORDER_EXTENDED_FILTER]: {
		...BRANCH_DEFAULT_BUTTONS,
		//* Selecters
		[AccessKey.COMPANIES_AND_TAXI_SERVICES]: BRANCH_DEFAULT_SELECTOR,
		//* CheckBox
		[AccessKey.ARCHIVE_FILTER_EXECUTOR]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_STATUS_ORDER]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_NUMBER_ORDER]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_NUMBER_PHONE]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_STREET]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_CLIENT]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_COUNTERPARTY]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_AGENT]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_PAYMENTS]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_CLASSES]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_SERVICES]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_SECTORS]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_TRANSFER]: BRANCH_DEFAULT_CHECK_BOXS,
		[AccessKey.ARCHIVE_FILTER_SOURCE_CALL_SIGN]: BRANCH_DEFAULT_CHECK_BOXS,
	},
};

export {
	BRANCH_DEFAULT,
	BRANCH_NOT_SHOW,
	//
	BRANCH_DEFAULT_MENU,
	BRANCH_DEFAULT_PAGES,
	BRANCH_DEFAULT_TABS,
	BRANCH_DEFAULT_BUTTONS,
	BRANCH_DEFAULT_WIDGETS,
	BRANCH_DEFAULT_MODALS,
	BRANCH_DEFAULT_FIELDS,
	BRANCH_DEFAULT_CHECK_BOXS,
	BRANCH_DEFAULT_CARD_ORDERS,
	BRANCH_DEFAULT_SELECTOR,
	BRANCH_DEFAULT_EDITORS,
	BRANCH_DEFAULT_RADIO_BUTTONS,
	BRANCH_DEFAULT_PERMISSION,
	BRANCH_DEFAULT_PERFORMER_CARD,
	BRANCH_DEFAULT_TRANSPORT_CARD,
	BRANCH_DEFAULT_BLOCKS,
	//
	BRANCH_CONTROL_BUTTONS,
	BRANCH_CONTROL_AND_ADDITIONAL_BUTTONS,
	BRANCH_PANEL_POINT,
	BRANCH_FILTER_ORDER_MODAL,
};
